import React, { Component, Fragment } from "react";
import SimpleModalWrapped from "../common/Modal";
import { withStyles } from "@mui/styles";
import SingleSelect from "../common/SingleSelect";

import {
  Box,
  Grid,
  Tooltip,
  IconButton,
  Typography,
  FormControlLabel,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import "react-toastify/dist/ReactToastify.css";
import Button from "../common/Button";
import TextField from "../common/TextField";
import Switch from "../common/Switch";
import MultiSelect from "./MultiSelect";
import { Info } from "@mui/icons-material";
import MarkerMap from "../common/Maps";
import CustomDialog from "../common/Dialog";
import EditIcon from "@mui/icons-material/Place";
import VehicleCategoryModal from "../Vehicle/VehicleCategoryModal";

const styles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  dense: {
    marginTop: 19,
  },
  menu: {
    width: 200,
  },
  button: {
    margin: theme.spacing(1),
  },
});
const GarageTypes = [
  {
    key: "Default",
    name: "Default",
  },
  {
    key: "Abu Dhabi",
    name: "Abu Dhabi",
  },
  {
    key: "Dubai",
    name: "Dubai",
  },
  {
    key: "Sharjah",
    name: "Sharjah",
  },
  {
    key: "Ajman",
    name: "Ajman",
  },
  {
    key: "Umm Al Quwain",
    name: "Umm Al Quwain",
  },
  {
    key: "Ras Al Khaimah",
    name: "Ras Al Khaimah",
  },
  {
    key: "Fujairah",
    name: "Fujairah",
  },
];

const GarageStatus = [
  {
    key: "Active",
    name: "Active",
  },
  {
    key: "Suspended",
    name: "Suspended",
  },
  {
    key: "Blacklisted",
    name: "Blacklisted",
  },
  {
    key: "Under monitoring",
    name: "Under monitoring",
  },
];

const GarageSla = [
  {
    key: "Platinum",
    name: "Platinum",
  },
  {
    key: "Standard",
    name: "Standard",
  },
];

const GarageAff = [
  {
    key: "OEM / Authorized Dealers",
    name: "OEM / Authorized Dealers",
  },
  {
    key: "Independent Workshop",
    name: "Independent Workshop",
  },
  {
    key: "Independent Shop",
    name: "Independent Shop",
  },
  {
    key: "Mobile SP",
    name: "Mobile SP",
  },
];

const GarageServiceType = [
  {
    value: "Engine Oil Change",
    label: "Engine Oil Change",
  },
  {
    value: "Preventive Maintenance (PMS)",
    label: "Preventive Maintenance (PMS)",
  },
  {
    value: "Mechanical Repairs",
    label: "Mechanical Repairs",
  },
  {
    value: "Electrical Repairs",
    label: "Electrical Repairs",
  },
  {
    value: "AC Service",
    label: "AC Service",
  },
  {
    value: "Tires Service",
    label: "Tires Service",
  },
  {
    value: "Battery Service",
    label: "Battery Service",
  },
  {
    value: "Body and Paint",
    label: "Body and Paint",
  },
  {
    value: "Diagnostics",
    label: "Diagnostics",
  },
  {
    value: "Glass Repair/Replacement",
    label: "Glass Repair/Replacement",
  },
  {
    value: "Refrigeration Service",
    label: "Refrigeration Service",
  },
  {
    value: "Car Wash",
    label: "Car Wash",
  },
];
const WEEK_DAYS = [
  { key: "sunday", label: "Sunday" },
  { key: "monday", label: "Monday" },
  { key: "tuesday", label: "Tuesday" },
  { key: "wednesday", label: "Wednesday" },
  { key: "thursday", label: "Thursday" },
  { key: "friday", label: "Friday" },
  { key: "saturday", label: "Saturday" },
];

const DEFAULT_FROM_24 = "09:00";
const DEFAULT_TO_24 = "18:00";

const padTime = (value) => String(value || 0).padStart(2, "0");

const to12Hour = (time24) => {
  if (!time24) return "";
  const [hourStr, minuteStr = "00"] = String(time24).split(":");
  let hour = parseInt(hourStr, 10);
  if (Number.isNaN(hour)) return "";
  const period = hour >= 12 ? "PM" : "AM";
  hour = hour % 12;
  if (hour === 0) hour = 12;
  return `${hour}:${padTime(minuteStr)} ${period}`;
};

const to24Hour = (time12) => {
  if (!time12) return "";
  const value = String(time12).trim();
  if (/^\d{1,2}:\d{2}$/.test(value)) {
    const [h, m] = value.split(":");
    return `${padTime(h)}:${padTime(m)}`;
  }
  const match = value.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
  if (!match) return "";
  let hour = parseInt(match[1], 10);
  const minute = match[2];
  const period = match[3].toUpperCase();
  if (period === "AM") {
    hour = hour === 12 ? 0 : hour;
  } else {
    hour = hour === 12 ? 12 : hour + 12;
  }
  return `${padTime(hour)}:${padTime(minute)}`;
};

const getDefaultWeekHours = () =>
  WEEK_DAYS.map((day) => ({
    day: day.label,
    open: true,
    from: to12Hour(DEFAULT_FROM_24),
    to: to12Hour(DEFAULT_TO_24),
  }));

export const parseWorkingHours = (value) => {
  const defaults = getDefaultWeekHours();
  if (!value) return defaults;

  let list = [];
  if (Array.isArray(value)) {
    list = value;
  } else if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      list = Array.isArray(parsed)
        ? parsed
        : parsed && typeof parsed === "object"
          ? Object.keys(parsed).map((key) => ({
              day: key,
              ...parsed[key],
            }))
          : [];
    } catch (e) {
      return defaults;
    }
  } else if (typeof value === "object") {
    list = Object.keys(value).map((key) => ({
      day: key,
      ...value[key],
    }));
  }

  if (!list.length) return defaults;

  return WEEK_DAYS.map((day, index) => {
    const item =
      list.find(
        (entry) =>
          String(entry?.day || "").toLowerCase() === day.key ||
          String(entry?.day || "").toLowerCase() === day.label.toLowerCase(),
      ) ||
      list[index] ||
      {};
    const isOpen =
      item.open === true ||
      String(item.status || item.open || "").toLowerCase() === "open";
    const from24 = to24Hour(item.from) || DEFAULT_FROM_24;
    const to24 = to24Hour(item.to) || DEFAULT_TO_24;
    return {
      day: day.label,
      key: day.key,
      open: isOpen,
      from: to12Hour(from24),
      to: to12Hour(to24),
    };
  });
};

export const serializeWorkingHours = (hours) => {
  const list = Array.isArray(hours) ? hours : parseWorkingHours(hours);
  return WEEK_DAYS.reduce((acc, day) => {
    const item =
      list.find(
        (entry) =>
          String(entry?.key || "").toLowerCase() === day.key ||
          String(entry?.day || "").toLowerCase() === day.key ||
          String(entry?.day || "").toLowerCase() === day.label.toLowerCase(),
      ) || {};
    acc[day.key] = {
      open: item.open === true,
      from: item.from || to12Hour(DEFAULT_FROM_24),
      to: item.to || to12Hour(DEFAULT_TO_24),
    };
    return acc;
  }, {});
};

export const getDefaultWorkingHoursObject = () =>
  serializeWorkingHours(getDefaultWeekHours());

const GarageAminities = [
  {
    value: "Customer Waiting Lounge",
    label: "Customer Waiting Lounge",
  },
  {
    value: "Covered Parking",
    label: "Covered Parking",
  },
  {
    value: "Free WiFi",
    label: "Free WiFi",
  },
  {
    value: "Air Conditioning",
    label: "Air Conditioning",
  },
  {
    value: "Restrooms",
    label: "Restrooms",
  },
  {
    value: "Pick & Drop Service",
    label: "Pick & Drop Service",
  },
  {
    value: "CCTV Security",
    label: "CCTV Security",
  },
  {
    value: "Online Booking",
    label: "Online Booking",
  },
  {
    value: "Digital Payment Options",
    label: "Digital Payment Options",
  },
  {
    value: "Diagnostic Scanning",
    label: "Diagnostic Scanning",
  },
];

class addWorkShops extends Component {
  constructor() {
    super();
    this.state = {
      categoryModalOpen: false,
    };
  }

  handleWorkingHoursChange = (dayLabel, field, value) => {
    const hours = parseWorkingHours(this.props.data?.attributes?.workinghours);
    const updated = hours.map((item) => {
      if (item.day !== dayLabel) return item;
      if (field === "open") {
        return { ...item, open: Boolean(value) };
      }
      if (field === "from" || field === "to") {
        return { ...item, [field]: to12Hour(value) };
      }
      return item;
    });
    this.props.handleChangeDropdowns(
      "workinghours",
      serializeWorkingHours(updated),
    );
  };

  render() {
    const {
      data: form,
      handleChange,
      categoriesList,
      allMakes,
      makesLoading,
      searchMakesList,
      loadMoreMakes,
      handleChangeDropdowns,
      translate,
      handleChange1,
      fetchCategories,
    } = this.props;
    const SLA_TOOLTIPS = {
      Platinum: "24/7 recovery and guaranteed 4-hour turnaround",
      Standard: "Standard business hours with 24–48 hour turnaround",
    };
    const slaTooltipValue = SLA_TOOLTIPS[form?.sla?.key] || "";
    // const {form}=this.props.data;

    // const defaultZones = []
    // timeZonesTypes.map((item, i) => {
    //   if (i <= 9) {
    //     defaultZones.push({
    //       id: item.key,
    //       key: item.key,
    //       label: item.key,
    //       value: item.key
    //     })
    //   }
    // })

    return (
      <Fragment>
        <SimpleModalWrapped
          {...this.state}
          {...this.props}
          visable
          isButtonVisable
          title={this.props.title}
          isNotShowAttributesBtn
          formSubmit={this.props.formSubmit}
          // addAttributes={this.addAttributes}
          modalControle={this.props.modalControle}
          btnclosetext={this.props.translate("sharedBack")}
          buttonText={this.props.buttonText}
          // isVisableBtn={true}
          isVisableBtn={this.props.isVisableAddBtn}
          notVisableBackbtn={false}
          // showPortList={this.props.showPortList}
          // showPort={this.props.showPort}
          content={
            <>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField
                    id="name"
                    required
                    margin="dense"
                    label={this.props.translate("sharedName")}
                    variant="outlined"
                    fullWidth
                    value={this.props.data?.name}
                    onChange={this.props.handleChange("name")}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField
                    id="description"
                    margin="dense"
                    label={this.props.translate("sharedDescription")}
                    variant="outlined"
                    fullWidth
                    value={this.props.data?.description}
                    onChange={this.props.handleChange("description")}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField
                    id="garageNumber"
                    type="number"
                    margin="dense"
                    required
                    label={this.props.translate("workshopNumber")}
                    variant="outlined"
                    fullWidth
                    value={this.props.data?.garageNumber}
                    onChange={this.props.handleChange("garageNumber")}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} style={{ zIndex: 99 }}>
                  {/* {console.log("this.props.data?.garageType====", this.props.data?.garageType)} */}
                  <SingleSelect
                    array={GarageTypes || []}
                    async
                    selectName="garageType"
                    // isClearable
                    label={this.props.translate("workshopType")}
                    value={
                      this.props.data && this.props.data?.garageType
                        ? {
                            id:
                              this.props.data?.garageType.key ||
                              this.props.data?.garageType,
                            value:
                              this.props.data?.garageType.name ||
                              this.props.data?.garageType,
                            label:
                              this.props.data?.garageType.name ||
                              this.props.translate(this.props.data?.garageType),
                          }
                        : ""
                    }
                    required
                    // value={this.props.form.reportNumber || ""}
                    handleChange={this.props.handleChange1}
                    canAssign={true}
                    menuPlacement="auto"
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                  {/* <TextField
                    id="garageType"
                    margin="dense"
                    label={this.props.translate("garageType")}
                    variant="outlined"
                    fullWidth
                    value={this.props.data?.garageType}
                    onChange={this.props.handleChange("garageType")}
                  /> */}
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField
                    id="garageArea"
                    margin="dense"
                    label={this.props.translate("workshopArea")}
                    variant="outlined"
                    fullWidth
                    value={this.props.data?.garageArea}
                    onChange={this.props.handleChange("garageArea")}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <SingleSelect
                    array={this.props.garageCities || []}
                    async
                    selectName="garageCity"
                    isClearable
                    label={this.props.translate("workshopCity")}
                    value={
                      this.props.data && this.props.data?.garageCity
                        ? {
                            id:
                              this.props.data?.garageCity?.id ||
                              this.props.data?.garageCity,
                            value:
                              this.props.data?.garageCity?.cityEn ||
                              this.props.data?.garageCity?.name ||
                              this.props.data?.garageCity,
                            label:
                              this.props.data?.garageCity?.cityEn ||
                              this.props.data?.garageCity?.name ||
                              this.props.translate(this.props.data?.garageCity),
                          }
                        : ""
                    }
                    required
                    // value={this.props.form.reportNumber || ""}
                    handleChange={this.props.handleChange1}
                    canAssign={true}
                    menuPlacement="auto"
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                  {/* <TextField
                    id="garageCity"
                    margin="dense"
                    label={this.props.translate("garageCity")}
                    variant="outlined"
                    fullWidth
                    value={this.props.data?.garageCity}
                    onChange={this.props.handleChange("garageCity")}
                  /> */}
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField
                    id="garageManager"
                    margin="dense"
                    label={this.props.translate("workshopManager")}
                    variant="outlined"
                    fullWidth
                    value={this.props.data?.garageManager}
                    onChange={this.props.handleChange("garageManager")}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField
                    id="email"
                    margin="dense"
                    label={this.props.translate("userEmail")}
                    variant="outlined"
                    fullWidth
                    value={this.props.data?.email}
                    onChange={this.props.handleChange("email")}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField
                    id="phone"
                    margin="dense"
                    label={this.props.translate("sharedPhone")}
                    variant="outlined"
                    fullWidth
                    value={this.props.data?.phone}
                    onChange={this.props.handleChange("phone")}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField
                    id="address"
                    margin="dense"
                    label={this.props.translate("address")}
                    variant="outlined"
                    fullWidth
                    value={this.props.data?.address}
                    onChange={this.props.handleChange("address")}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField
                    id="latitude"
                    type="number"
                    margin="dense"
                    label={this.props.translate("positionLatitude")}
                    placeholder=""
                    variant="outlined"
                    fullWidth
                    value={
                      this.props.data?.latitude ? this.props.data?.latitude : ""
                    }
                    onChange={this.props.handleChange("latitude")}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                >
                  <TextField
                    id="longitude"
                    type="number"
                    margin="dense"
                    label={this.props.translate("positionLongitude")}
                    placeholder=""
                    variant="outlined"
                    fullWidth
                    value={
                      this.props.data?.longitude
                        ? this.props.data?.longitude
                        : ""
                    }
                    onChange={this.props.handleChange("longitude")}
                  />
                  <Tooltip
                    title={
                      this.props.translate?.("addLocation") || "Add Location"
                    }
                  >
                    <IconButton
                      onClick={this.props.handleClickShowPostion}
                      sx={{
                        color: "gray",
                        "&:hover": {
                          color: this.props.themecolors["500"],
                        },
                      }}
                    >
                      <EditIcon />
                    </IconButton>
                  </Tooltip>
                </Grid>
                {/* <Grid item sm={3} xs={12}> */}
                {/* <Tooltip title={translate('addLocation')}>
              <IconButton onClick={()=>handleClickShowPostion()}>
                {<EditIcon style={{ color:"#ffffff"}} />}
              </IconButton>
            </Tooltip> */}
                {/* </Grid> */}
                {/* <Tooltip title={this.props.translate('addLocation')}>
              <IconButton onClick={this.handleClickShowPostion}>
                {<EditIcon />}
              </IconButton>
            </Tooltip> */}
                {/* <Grid item xs={12} sm={6} md={4} lg={3}>
           <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                format="DD/MM/YYYY"
                margin='dense'
                label={translate('created')}
                variant='outlined'
                fullWidth
                value={form.created? new Date( `${form.created}` ).toString() : null}
                onChange={handleChangeLicenseExpDate('created')}
                InputProps={{
                  classes: {
                    root: 'theme-cssOutlinedInput',
                    input: 'theme-input',
                    focused: 'theme-cssFocused',
                    notchedOutline: 'theme-notchedOutline'
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: 'theme-label',
                    focused: 'theme-label-focused',
                    shrink: 'theme-label-shrink'
                  }
                }}
              />
          </LocalizationProvider>
        </Grid> */}

                {/* <Grid item xs={12}>
            <Checkbox
              checked={form.attributes.enable}
              onChange={e => handleChangeAttributes('archive', e.target.checked)}
              color='primary'
              label={translate('archive')}
              name='enable'
            />
          </Grid> */}
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField
                    id="tradeLicNo"
                    name="tradeLicNo"
                    type="number"
                    margin="dense"
                    label={translate("tradeLicNo")}
                    placeholder=""
                    variant="outlined"
                    fullWidth
                    value={form.tradeLicNo ? form.tradeLicNo : ""}
                    onChange={handleChange("tradeLicNo")}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField
                    id="vatNo"
                    type="number"
                    margin="dense"
                    label={translate("vatNo")}
                    placeholder=""
                    variant="outlined"
                    fullWidth
                    value={form.vatNo ? form.vatNo : ""}
                    onChange={handleChange("vatNo")}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField
                    id="maxVehicle"
                    type="number"
                    margin="dense"
                    label={translate("maxVehicle")}
                    placeholder=""
                    variant="outlined"
                    fullWidth
                    value={form.maxVehicle ? form.maxVehicle : ""}
                    onChange={handleChange("maxVehicle")}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField
                    id="bays"
                    type="number"
                    margin="dense"
                    label={translate("bays")}
                    placeholder=""
                    variant="outlined"
                    fullWidth
                    value={form.bays ? form.bays : ""}
                    onChange={handleChange("bays")}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField
                    id="multiplier"
                    type="number"
                    margin="dense"
                    label={translate("multiplier")}
                    placeholder=""
                    variant="outlined"
                    fullWidth
                    value={form.multiplier ? form.multiplier : ""}
                    onChange={handleChange("multiplier")}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  style={{ postion: "relative", zIndex: 16 }}
                >
                  <SingleSelect
                    array={GarageStatus}
                    async
                    selectName="status"
                    required
                    isClearable={false}
                    label={this.props.translate("status")}
                    value={
                      form?.status
                        ? {
                            id: form?.status.key || form?.status,
                            value: form?.status.name || form?.status,
                            label: form?.status.name || form?.status,
                          }
                        : {
                            id: "Active",
                            value: "Active",
                            label: "Active",
                          }
                    }
                    handleChange={handleChange1}
                    canAssign={true}
                  />
                  {/* <MultiSelect
            array={GarageStatus}
            value={form.status}
            label={translate("status")}

            selectName="status"
            handleChange={handleChangeDropdowns}
          /> */}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  style={{ position: "relative", zIndex: 4 }}
                >
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 6 }}
                  >
                    <div style={{ flex: 1, postion: "relative", zIndex: 4 }}>
                      <SingleSelect
                        array={GarageSla}
                        selectName="sla"
                        label={translate("sla")}
                        async
                        value={
                          form?.sla
                            ? {
                                id: form?.sla.key || form?.sla,
                                value: form?.sla.name || form?.sla,
                                label: form?.sla.name || form?.sla,
                              }
                            : ""
                        }
                        handleChange={handleChange1}
                        canAssign={true}
                      />
                    </div>

                    <Tooltip title={slaTooltipValue}>
                      <Info style={{ cursor: "pointer" }} />
                    </Tooltip>
                  </div>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  style={{ postion: "relative", zIndex: 4 }}
                >
                  <SingleSelect
                    array={GarageAff}
                    async
                    selectName="affiliation"
                    isClearable
                    label={translate("affiliation")}
                    value={
                      form && form?.affiliation
                        ? {
                            id: form?.affiliation.key || form?.affiliation,
                            value: form?.affiliation.name || form?.affiliation,
                            label: form?.affiliation.name || form?.affiliation,
                          }
                        : ""
                    }
                    // value={this.props.form.reportNumber || ""}
                    handleChange={handleChange1}
                    canAssign={true}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <MultiSelect
                    array={allMakes ? allMakes : []}
                    serverPaginated
                    isLoading={makesLoading}
                    onSearchChange={searchMakesList}
                    onMenuScrollToBottom={loadMoreMakes}
                    value={form.attributes?.makers}
                    label={translate("makers")}
                    selectName="makers"
                    handleChange={handleChangeDropdowns}
                    enableSelectAll
                    translate={translate}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <MultiSelect
                    array={GarageServiceType}
                    value={form.attributes?.serviceTypes}
                    label={translate("serviceTypes")}
                    selectName="serviceTypes"
                    handleChange={handleChangeDropdowns}
                    enableSelectAll
                    translate={translate}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <Box display="flex" alignItems="flex-start" gap={0.5}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <MultiSelect
                        array={categoriesList || []}
                        value={form.attributes?.vehicleTypes}
                        label={translate("vehicleTypes")}
                        selectName="vehicleTypes"
                        handleChange={handleChangeDropdowns}
                        enableSelectAll
                        translate={translate}
                      />
                    </div>
                    <Tooltip title={translate("manageVehicleTypes")}>
                      <IconButton
                        size="small"
                        color="primary"
                        onClick={() =>
                          this.setState({ categoryModalOpen: true })
                        }
                        style={{ marginTop: 8 }}
                        aria-label={translate("manageVehicleTypes")}
                      >
                        <AddCircleOutlineIcon />
                      </IconButton>
                    </Tooltip>
                  </Box>
                  {this.state.categoryModalOpen && (
                    <VehicleCategoryModal
                      onClose={() =>
                        this.setState({ categoryModalOpen: false })
                      }
                      onCategoriesUpdated={fetchCategories}
                      translate={translate}
                    />
                  )}
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <MultiSelect
                    array={GarageAminities}
                    value={form.attributes?.amennities}
                    label={translate("amennities")}
                    selectName="amennities"
                    handleChange={handleChangeDropdowns}
                    enableSelectAll
                    translate={translate}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    variant="subtitle1"
                    style={{ fontWeight: 600, marginBottom: 8 }}
                  >
                    {translate("workingHours")}
                  </Typography>
                  {parseWorkingHours(form.attributes?.workinghours).map(
                    (item) => (
                      <Box
                        key={item.day}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          flexWrap: "wrap",
                          gap: 1.5,
                          py: 0.5,
                        }}
                      >
                        <Typography sx={{ minWidth: 110, fontSize: 14 }}>
                          {translate(item.day.toLowerCase())}
                        </Typography>
                        <FormControlLabel
                          sx={{ minWidth: 110, mr: 1 }}
                          control={
                            <Switch
                              checked={item.open}
                              onChange={(e) =>
                                this.handleWorkingHoursChange(
                                  item.day,
                                  "open",
                                  e.target.checked,
                                )
                              }
                              color="primary"
                            />
                          }
                          label={translate(item.open ? "open" : "closed")}
                        />
                        <TextField
                          type="time"
                          variant="standard"
                          value={to24Hour(item.from)}
                          disabled={!item.open}
                          onChange={(e) =>
                            this.handleWorkingHoursChange(
                              item.day,
                              "from",
                              e.target.value,
                            )
                          }
                          InputLabelProps={{ shrink: true }}
                          inputProps={{ step: 300 }}
                          sx={{ width: 130 }}
                        />
                        <Typography sx={{ mx: 0.5 }}>–</Typography>
                        <TextField
                          type="time"
                          variant="standard"
                          value={to24Hour(item.to)}
                          disabled={!item.open}
                          onChange={(e) =>
                            this.handleWorkingHoursChange(
                              item.day,
                              "to",
                              e.target.value,
                            )
                          }
                          InputLabelProps={{ shrink: true }}
                          inputProps={{ step: 300 }}
                          sx={{ width: 130 }}
                        />
                      </Box>
                    ),
                  )}
                </Grid>
              </Grid>
            </>
          }
        />

        {this.props.isMapModal && (
          <CustomDialog
            title={this.props.translate("setLocation")}
            themeColors={this.props.themeColors}
            visable={true}
            onClose={this.props.onCloseModal}
            isButtonVisable={true}
            draggable={true}
            fullWidth
            CancelText={this.props.translate("sharedBack")}
            headerActions={
              <Button
                size="small"
                variant="contained"
                color="secondary"
                disabled={!this.props.isVisableAddlocBtn}
                onClick={() => this.props.setSelectedLocation()}
              >
                {" "}
                {this.props.translate("sharedAdd")}
              </Button>
            }
            bodyPadding={0}
          >
            <MarkerMap
              getPostion={this.props.getPostion}
              minHeight={500}
              zoom={this.props.data?.zoom || 14}
              lat={this.props.data?.latitude || 25.186301620540558}
              lng={this.props.data?.longitude || 55.274276733398445}
              height={"100%"}
            />
          </CustomDialog>
        )}
      </Fragment>
    );
  }
}

const AddWorkShopsModal = withStyles(styles);
export default AddWorkShopsModal(addWorkShops);
